export default __webpack_public_path__ + "static/media/trr-drink-cocktail-javaslide.e9444c6a.png";